import { createActions } from 'redux-actions';

export default createActions(
  {
    RESET: () => ({}),
    INIT: (robotId) => ({ robotId }),
    REMOVE: (robotId) => ({ robotId }),
    TOGGLE_VISIBLE: (robotId, key) => ({ robotId, key }),
    CHANGE_TRACE_TYPE: (robotId, type) => ({ robotId, type }),
    CHANGE_PHOTO_TYPE: (robotId, type) => ({ robotId, type }),
  },
  { prefix: 'ROBOT_OPTIONS' },
);
